/** Orders / table ordering / POS users feature reducers */
export async function loadOrdersReducers() {
  const [
    order,
    tableOrders,
    tableActions,
    orderHistory,
    floorSetupReducer,
    PosUsers,
    posConfiguration,
    voidReason,
    kioskDeleteReason,
    transferReason,
    refundReason,
    minimumCharge,
  ] = await Promise.all([
    import('../reducers/OrderReducer'),
    import('../reducers/TableOrdersReducer'),
    import('../reducers/TableActionsReducer'),
    import('../reducers/OrderHistoryReducer'),
    import('../reducers/FloorSetupReducer'),
    import('../reducers/PosUsersReducer'),
    import('../reducers/PosConfigurationReducer'),
    import('../reducers/VoidReasonReducer'),
    import('../reducers/KioskDeleteReasonReducer'),
    import('../reducers/TransferReasonReducer'),
    import('../reducers/RefundReasonReducer'),
    import('../reducers/MinimumChargeReducer'),
  ]);

  return {
    order: order.default,
    tableOrders: tableOrders.default,
    tableActions: tableActions.default,
    orderHistory: orderHistory.default,
    floorSetupReducer: floorSetupReducer.default,
    PosUsers: PosUsers.default,
    posConfiguration: posConfiguration.default,
    voidReason: voidReason.default,
    kioskDeleteReason: kioskDeleteReason.default,
    transferReason: transferReason.default,
    refundReason: refundReason.default,
    minimumCharge: minimumCharge.default,
  };
}
